<template>
  <div class="content-container">
    <ContentBox :title="mode ==='edit' ? '编辑广告主账号' : '创建广告主账号'" class="content-box">
      <el-form
        class="demo-ruleForm"
        ref="addForm"
        :model="addForm"
        :rules="rules"
        label-width="120px"
        label-position="left"
        hide-required-asterisk
      >
        <el-form-item label="登录账号" prop="agentAccount" maxlength="45">
          <el-input v-model="addForm.agentAccount" />
        </el-form-item>
        <el-form-item label="登录密码" prop="loginPwd">
          <div v-if="showPwdText">
            <span>********</span>
            <span class="el-icon-edit" style="padding-left: 20px;color:#ff8b00;cursor:pointer" title="修改密码" @click="showPwdText = false"></span>
          </div>
          <el-input
            v-else
            v-model="addForm.loginPwd"
            type="password"
            maxlength="45"
            autocomplete="new-password"
            placeholder="必须包含数字、字母及特殊符号，长度不少于8位"
          />
        </el-form-item>
        <el-form-item v-if="!showPwdText" label="确认密码" prop="confirmLoginPwd">
          <el-input type="password" v-model="addForm.confirmLoginPwd" autocomplete="new-password" maxlength="45" />
        </el-form-item>
        <el-form-item label="账号名称" prop="agentAccountName">
          <el-input v-model="addForm.agentAccountName" maxlength="45" />
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="addForm.phone" />
        </el-form-item>
        <el-form-item prop="email">
          <span slot="label">
            <span>邮件地址</span>
            <span class="sub-title">(选填)</span>
          </span>
          <el-input v-model="addForm.email" />
        </el-form-item>
        <el-form-item label="广告主" prop="partnerId">
          <el-select v-model="addForm.partnerId" filterable placeholder="请选择广告主">
            <el-option v-for="item in adPartnerIdList" :key="item.partnerId" :label="item.partnerName" :value="item.partnerId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态" prop="disabled">
          <el-radio-group v-model="addForm.disabled">
            <el-radio :label="0">启用</el-radio>
            <el-radio :label="1">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
    </ContentBox>
    <ContentBox class="content-box">
      <el-button @click="handleQuit">取消</el-button>
      <el-button type="primary" @click="handleSave" :loading="loading">保存</el-button>
    </ContentBox>
  </div>
</template>
<script>
export default {
  props: ['mode', 'id'],
  data() {
    var validatorPhone = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请填写手机号'))
      } else {
        if (value === this.oldForm.phone) {
          // 编辑时候不更改不需要校验
          callback()
        } else {
          const regx = /^1(3|4|5|7|8)\d{9}$/
          if (!regx.test(value)) {
            callback(new Error('请输入正确手机号'))
          } else {
            this.$service.checkPhone({ phone: this.$encrypt(value) }).then((data) => {
              if (data.isError) {
                callback(new Error('手机号已被使用，请重新输入'))
              } else {
                callback()
              }
            })
          }
        }
      }
    }
    var validateAccountName = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请填写账号名称'))
      } else {
        if (/^[\u4E00-\u9FA5A-Za-z0-9]{8,20}$/.test(value)) {
          callback()
        } else {
          callback(new Error('账号名称为8-20个字符，不能包含特殊符号或空格'))
        }
      }
    }
    var validateUserAccount = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请填写登录账号'))
      } else {
        if (value === this.oldForm.agentAccount) {
          // 编辑时候不更改不需要校验
          callback()
        } else {
          if (/^[A-Za-z]+$/g.test(value)) {
            this.$service.checkAccount({ agentAccount: this.$encrypt(value) }).then((data) => {
              if (data.isError) {
                callback(new Error('该登录账号已被使用，请重新输入'))
              } else {
                callback()
              }
            })
          } else {
            if (/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,20}$/.test(value)) {
              this.$service.checkAccount({ agentAccount: this.$encrypt(value) }).then((data) => {
                if (data.isError) {
                  callback(new Error('该登录账号已被使用，请重新输入'))
                } else {
                  callback()
                }
              })
            } else {
              callback(new Error('登录账号为8-20个字符，需为英文字母、数字的组合'))
            }
          }
        }
      }
    }
    var validatePwd = (rule, value, callback) => {
      if (!this.showPwdText && !value) {
        callback(new Error('请填写登录密码'))
      } else {
        if (value === this.oldForm.loginPwd) {
          // 编辑时候不更改不需要校验
          callback()
        } else {
          if (
            /^(?![A-Za-z0-9]+$)(?![A-Za-z\W]+$)(?![0-9\W]+$)[a-zA-Z0-9\W]{8,}$/.test(
              value
            )
          ) {
            if (value === this.addForm.agentAccount) {
              callback(new Error('密码不能与登录账号相同'))
            } else {
              callback()
            }
            callback()
          } else {
            callback(new Error('必须包含数字、字母及特殊符号，长度不少于8位'))
          }
          callback()
        }
      }
    }
    var validateConfirmLoginPwd = (rule, value, callback) => {
      if (!this.showPwdText && !value) {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.addForm.loginPwd) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      loading: false,
      addForm: {
        agentAccountId: undefined,
        agentAccount: '',
        loginPwd: undefined,
        confirmLoginPwd: undefined,
        agentAccountName: '',
        phone: '',
        email: '',
        partnerId: '',
        flag: 3,
        disabled: 0
      },
      rules: {
        agentAccount: [
          { required: true, validator: validateUserAccount, trigger: 'blur' }
        ],
        loginPwd: [{ required: true, validator: validatePwd, trigger: 'blur' }],
        confirmLoginPwd: [
          { required: true, validator: validateConfirmLoginPwd, trigger: 'blur' }
        ],
        agentAccountName: [
          { required: true, validator: validateAccountName, trigger: 'blur' }
        ],
        partnerId: [{ required: true, message: '请选择广告主', trigger: 'change' }],
        phone: [{ required: true, validator: validatorPhone, trigger: 'blur' }]
      },
      adPartnerIdList: [],
      oldForm: {},
      showPwdText: false
    }
  },
  methods: {
    handleSave() {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          const params = this.cloneDeep(this.addForm)
          this.loading = true
          params.agentAccount = this.$encrypt(params.agentAccount)
          params.loginPwd = params.loginPwd ? this.$encrypt(params.loginPwd) : undefined
          params.confirmLoginPwd = params.confirmLoginPwd ? this.$encrypt(params.confirmLoginPwd) : undefined
          params.phone = params.phone ? this.$encrypt(params.phone) : ''
          params.email = params.email ? this.$encrypt(params.email) : ''
          if (this.mode === 'edit') {
            this.$service
              .accAdDspCustomerEdit(params, '操作成功')
              .then((data) => {
                this.loading = false
                this.$emit('go-back', true)
              })
              .catch(() => {
                this.loading = false
              })
          } else {
            this.$service
              .accAdDspCustomerAdd(params, '操作成功')
              .then((data) => {
                this.loading = false
                this.$emit('go-back', true)
              })
              .catch(() => {
                this.loading = false
              })
          }
        }
      })
    },
    handleQuit() {
      const isChange = this.$consts.difference(this.addForm, this.oldForm)
      if (Object.keys(isChange).length > 0) {
        this.$confirm('页面内容未保存，确定要离开吗？', '提示', {
          confirmButtonText: '离开页面',
          cancelButtonText: '留在页面',
          center: true,
          type: 'warning'
        })
          .then(() => {
            this.$emit('go-back', false)
          })
          .catch(() => {})
      } else {
        this.$emit('go-back', false)
      }
    },
    getAccAdAgentAccountDataList() {
      this.$service
        .getAccAdAgentAccountDataList({})
        .then((data) => {
          this.adPartnerIdList = data
        })
        .catch(() => {})
    },
    getAccAdDspCustomerDetail() {
      this.$service
        .getAccAdDspCustomerDetail({ agentAccountId: this.id })
        .then((data) => {
          this.addForm.agentAccountId = data.agentAccountId
          this.addForm.agentAccount = this.$decrypt(data.agentAccount)
          this.addForm.agentAccountName = data.agentAccountName
          this.addForm.phone = this.$decrypt(data.phone)
          this.addForm.email = this.$decrypt(data.email)
          this.addForm.partnerId = data.partnerId
          this.addForm.flag = data.flag
          this.addForm.disabled = data.disabled
          this.oldForm = JSON.parse(JSON.stringify(this.addForm))
          this.showPwdText = true
        })
        .catch(() => {})
    }
  },
  created() {
    if (this.mode === 'edit') {
      this.getAccAdDspCustomerDetail()
    } else {
      this.oldForm = JSON.parse(JSON.stringify(this.addForm))
    }
    this.getAccAdAgentAccountDataList()
  }
}
</script>、
<style lang="stylus" scoped>
.content-container
  margin 16px
>>>.title
  padding-left 32px
>>>.content-box__main
  margin-left 32px
.demo-ruleForm
  width 584px
>>>.el-select
  display flex
.sub-title
  color rgba(0, 0, 0, 0.65)
  padding 0 5px
</style>
